module.exports = __webpack_public_path__ + "img/invited-by-influencer-icon.088a0b7b.svg";